import $ from 'jquery';
import 'slick-carousel';


$( ".carousel__slider" ).slick( {
	// normal options...
	infinite:       false,
	appendArrows:   false,
	variableWidth:  false,
	centerMode:     false,
	slidesToShow:   1,
	slidesToScroll: 1,
	dots:           true,
	arrows:         true,
	focusOnSelect:  false,
} );

let slides = 3;

if ($( ".content_3_columns" )) {
	slides = $( ".content_3_columns" ).data( "slides" );
}

$( ".content_3_columns" ).slick( {
	infinite:       false,
	mobileFirst:    true,
	appendArrows:   false,
	variableWidth:  false,
	centerMode:     false,
	slidesToShow:   1,
	slidesToScroll: 1,
	dots:           true,
	arrows:         false,
	focusOnSelect:  false,
	responsive:     [
		{
			breakpoint: 768,
			settings:   {
				slidesToShow:   2,
				slidesToScroll: 1,
			}
		},
		{
			breakpoint: 1024,
			settings:   {
				slidesToShow:   slides,
				slidesToScroll: 1,
			}
		}
	]
} );
